import { render, staticRenderFns } from "./MetricsTable.vue?vue&type=template&id=7b03ba0a&"
import script from "./MetricsTable.vue?vue&type=script&lang=js&"
export * from "./MetricsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports